<template>
    <div>
        <el-popover
            v-if="inspectionEndpointUsageStats"
            class="inline"
            placement="left"
            trigger="click"
            >
            <div>
                <table class="table border-gray-300 b-1" v-if="inspectionEndpointUsageStats">

                    <thead>
                        <tr>
                            <th style="min-width: 150px"></th>
                            <th class="text-center">Old App</th>
                            <th class="text-center">New App</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(count, key) in inspectionEndpointUsageStats.stats">
                            <td>{{ key | titlecase }}</td>
                            <td class="text-center">{{ count["old_app"] > 0 ? count["old_app"] : "" }}</td>
                            <td class="text-center">{{ count["new_app"] > 0 ? count["new_app"] : "" }}</td>
                        </tr>
                    </tbody>

                </table>
                <button
                    class="flex w-full items-center justify-center text-center block py-1 rounded-md border border-indigo-300 text-indigo-600 font-medium cursor-pointer hover:text-indigo-400"
                    @click.prevent="updateInspectionEndpointUsageStats"> {{ inspectionEndpointUsageStatsLoading ? "Updating..." : "Update" }}
                </button>
            </div>
            <badge slot="reference" class="cursor-pointer bg-yellow-100 text-yellow-600 p-4 text-md" v-if="inspectionEndpointUsageStats">
                <div v-if="inspectionEndpointUsageStats.app_used === 'Old App'">
                    {{ inspectionEndpointUsageStats.app_used }} {{ inspectionEndpointUsageStats.stats["total"]["old_app"] }}
                </div>

                <div v-else-if="inspectionEndpointUsageStats.app_used === 'New App'">
                    {{ inspectionEndpointUsageStats.app_used }} {{ inspectionEndpointUsageStats.stats["total"]["new_app"] }}
                </div>

                <div v-else-if="inspectionEndpointUsageStats.app_used === 'Both Apps'">
                    New App {{ inspectionEndpointUsageStats.stats["total"]["new_app"] }} Old App {{ inspectionEndpointUsageStats.stats["total"]["old_app"] }}
                </div>

                <div v-else>{{ inspectionEndpointUsageStatsLoading ? "..." : inspectionEndpointUsageStats.app_used }}</div>
            </badge>
        </el-popover>

    </div>
</template>

<script>
export default {
    name: "InspectionEndpointUsageStats",
    props: {
        inspection: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            inspectionEndpointUsageStats: null,
            inspectionEndpointUsageStatsLoading: false
        };
    },
    mounted () {
        this.fetchInspectionEndpointUsageStats();
    },
    methods: {
        fetchInspectionEndpointUsageStats () {
            this.inspectionEndpointUsageStatsLoading = true;
            axios.get("/inspections/" + this.inspection.id + "/endpoint-usage")
            .then(response => {
                this.inspectionEndpointUsageStatsLoading = false;
                this.inspectionEndpointUsageStats = response.data;
            })
            .catch(error => {
                this.inspectionEndpointUsageStatsLoading = false;
            });
        },
        updateInspectionEndpointUsageStats () {
            this.inspectionEndpointUsageStatsLoading = true;
            App.patch("/inspections/" + this.inspection.id + "/endpoint-usage", new AppForm({}))
            .then(response => {
                this.inspectionEndpointUsageStatsLoading = false;
                this.inspectionEndpointUsageStats = response;
            })
            .catch(error => {
                this.inspectionEndpointUsageStatsLoading = false;
            });
        },
    }
};
</script>

<style scoped>

</style>
